export default {
  common: {
  },
  app: {
  },
  listaMudancas: {
    tipos: {
      '1': 'Entrada',
      '2': 'Saída'
    }
  },
  achadosPerdidos: {
    historico: {
      situacoes: {
        "1_1_1": "Perdido",
        "1_2_0": "Transferido",
        "1_3_0": "Devolvido",
        "1_3_1": "Encontrado",
        "2_2_0": "Transferido",
        "2_2_1": "Encontrado",
        "2_3_0": "Devolvido",
        "2_3_1": "Encontrado",
        "1_0_0": "Denunciado",
        "1_0_1": "Denunciado",
        "2_0_0": "Denunciado",
        "2_0_1": "Denunciado",
        "3_0_0": "Denunciado",
        "3_0_1": "Denunciado"
      }
    }
  },
  listaAcoes: {
    status: {
      PENDENTE: "Pendente",
      CONFIRMADA: "Confirmado",
      CANCELADA: "Cancelado"
    },
    actions: {
      reactivate: "Reativar",
      activate: "Ativar",
      deactivate: "Desativar"
    }
  },
  /*["pendencias-RESERVA"]: {
    actions: {
      reactivate: "Reagendar",
      activate: "Aprovar",
      deactivate: "Cancelar"
    }
  },*/
  meusRegistros: {
    title: "Meus Registros",
    actions: {
      reactivate: "Reabrir",
      activate: "Resolvido",
      deactivate: "Cancelar"
    }
  },
  pendencias: {
    title: "Pendências",
    usuarios: {
      PROBLEMA: "{{usuario}} ({{andar}})",
      RESERVA: "Apt {{usuario}}"
    },
    labelDetalhe: {
      PROBLEMA: {
        andar: "Andar",
        local: "Local",
        categoria: "Categoria",
        observacao: "Observação"
      },
      RESERVA: {
        local: "Área"
      }
    },
    tipos: {
      PROBLEMA: "Problema - {{categoria}} » {{local}}",
      RESERVA: "Reserva - {{local}}"
    },
    actions: {
      reactivate: "Responder",
      activate: "Responder",
      deactivate: "Resolvido"
    }
  }
}


// WEBPACK FOOTER //
// ./src/locales/lang-pt.js